import {Routes} from '@angular/router'
import {ROUTE_SOURCES, ROUTE_SOURCES_HOME} from '../../application/constants'
import {authGuard} from '../../application/auth.guard'

export default [
  {
    path: ROUTE_SOURCES,
    canActivate: [authGuard],
    loadComponent: () => import('./sources-screen-holder.component').then(c => c.SourcesScreenHolderComponent),
    children: [
      {
        path: ROUTE_SOURCES_HOME,
        pathMatch: 'full',
        loadComponent: () =>
          import('./home/sources-home.component').then(c => c.SourcesHomeComponent)
      },
      {
        path: '**',
        redirectTo: ROUTE_SOURCES_HOME
      }
    ]
  }
] as Routes
